/* Guishoes - Página de produto premium minimalista */
(function () {
  function money(cents) {
    var s = (cents / 100).toFixed(2).replace('.', ',');
    return 'R$ ' + s.replace(/\B(?=(\d{3})+(?!\d))/g, '.');
  }

  function init(root) {
    if (root.dataset.gspReady) return;
    root.dataset.gspReady = '1';

    var vEl = root.querySelector('[data-gsp-variants]');
    var variants = vEl ? JSON.parse(vEl.textContent) : [];
    var pixPct = parseInt(root.dataset.pix, 10) || 0;
    var parcelas = parseInt(root.dataset.parcelas, 10) || 1;
    var idInput = root.querySelector('[data-gsp-id]');
    var addBtns = root.querySelectorAll('[data-gsp-add]');
    var track = root.querySelector('[data-gsp-track]');
    var groups = root.querySelectorAll('.gsp-values');

    function each(sel, fn) { root.querySelectorAll(sel).forEach(fn); }

    function selected() {
      var opts = [];
      groups.forEach(function (g) {
        var c = g.querySelector('input:checked');
        opts.push(c ? c.value : null);
      });
      return opts;
    }

    function find(opts) {
      for (var i = 0; i < variants.length; i++) {
        var v = variants[i], ok = true;
        for (var j = 0; j < opts.length; j++) {
          if (v.options[j] !== opts[j]) { ok = false; break; }
        }
        if (ok) return v;
      }
      return null;
    }

    function setBtns(v) {
      addBtns.forEach(function (b) {
        if (!v) { b.disabled = true; b.textContent = root.dataset.labelNa; return; }
        b.disabled = !v.available;
        b.textContent = v.available ? root.dataset.labelAdd : root.dataset.labelSold;
      });
    }

    function update(fromUser) {
      if (!groups.length) return;
      var opts = selected();
      var v = find(opts);

      each('[data-gsp-optval]', function (b) {
        b.textContent = opts[parseInt(b.dataset.gspOptval, 10)] || '';
      });

      each('.gsp-values input', function (inp) {
        var pos = parseInt(inp.dataset.gspPos, 10) - 1;
        var test = opts.slice();
        test[pos] = inp.value;
        var m = find(test);
        inp.classList.toggle('is-na', !(m && m.available));
      });

      setBtns(v);
      if (!v) return;
      if (idInput) idInput.value = v.id;

      var hasCmp = v.compare_at_price && v.compare_at_price > v.price;
      each('[data-gsp-price]', function (e) { e.textContent = money(v.price); });
      each('[data-gsp-compare]', function (e) { e.hidden = !hasCmp; if (hasCmp) e.textContent = money(v.compare_at_price); });
      each('[data-gsp-save]', function (e) { e.hidden = !hasCmp; if (hasCmp) e.textContent = 'Economize ' + money(v.compare_at_price - v.price); });
      each('[data-gsp-off]', function (e) { e.hidden = !hasCmp; if (hasCmp) e.textContent = '-' + Math.round((v.compare_at_price - v.price) * 100 / v.compare_at_price) + '%'; });
      each('[data-gsp-pix]', function (e) { e.textContent = money(Math.floor(v.price * (100 - pixPct) / 100)); });
      each('[data-gsp-parcela]', function (e) { e.textContent = money(Math.floor(v.price / parcelas)); });

      if (!fromUser) return;
      if (v.featured_media && track && window.innerWidth < 990) {
        var s = track.querySelector('[data-media-id="' + v.featured_media.id + '"]');
        if (s) track.scrollTo({ left: s.offsetLeft - track.offsetLeft, behavior: 'smooth' });
      }
      try {
        var u = new URL(window.location.href);
        u.searchParams.set('variant', v.id);
        window.history.replaceState(null, '', u.toString());
      } catch (e) {}
    }

    each('.gsp-values input', function (i) {
      i.addEventListener('change', function () { update(true); });
    });
    update(false);

    /* Quantidade */
    var qty = root.querySelector('[data-gsp-qty]');
    each('[data-gsp-step]', function (b) {
      b.addEventListener('click', function () {
        if (!qty) return;
        var n = (parseInt(qty.value, 10) || 1) + parseInt(b.dataset.gspStep, 10);
        qty.value = Math.max(1, n);
      });
    });

    /* Contador da galeria (celular) */
    var idx = root.querySelector('[data-gsp-idx]');
    if (track && idx) {
      track.addEventListener('scroll', function () {
        var w = track.clientWidth || 1;
        idx.textContent = Math.round(track.scrollLeft / w) + 1;
      }, { passive: true });
    }

    /* Modais */
    each('[data-gsp-open]', function (b) {
      b.addEventListener('click', function () {
        var d = document.getElementById(b.dataset.gspOpen);
        if (d && d.showModal) d.showModal();
      });
    });
    each('dialog.gsp-dialog', function (d) {
      d.addEventListener('click', function (e) { if (e.target === d) d.close(); });
      d.addEventListener('close', function () {
        var v = d.querySelector('video');
        if (v) { v.pause(); v.removeAttribute('src'); v.load(); }
      });
    });
    each('[data-gsp-close]', function (b) {
      b.addEventListener('click', function () { var d = b.closest('dialog'); if (d) d.close(); });
    });

    /* Vídeos */
    var vd = root.querySelector('[data-gsp-video-dialog]');
    each('[data-gsp-reel]', function (r) {
      r.addEventListener('click', function () {
        if (!vd || !vd.showModal) return;
        var v = vd.querySelector('video');
        v.src = r.dataset.gspReel;
        vd.showModal();
        var p = v.play();
        if (p && p.catch) p.catch(function () {});
      });
    });

    /* Pessoas vendo agora */
    var live = root.querySelector('[data-gsp-live]');
    if (live) {
      var min = parseInt(live.dataset.min, 10) || 10, max = parseInt(live.dataset.max, 10) || 40;
      var rnd = function () { return Math.floor(Math.random() * (max - min + 1)) + min; };
      live.textContent = rnd();
      setInterval(function () { live.textContent = rnd(); }, 9000);
    }

    /* Barra fixa no celular */
    var sticky = root.querySelector('[data-gsp-sticky]');
    var buyRow = root.querySelector('[data-gsp-buyrow]');
    var mainAdd = root.querySelector('[data-gsp-main-add]');
    if (sticky && buyRow && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        var e = entries[0];
        sticky.classList.toggle('is-on', !e.isIntersecting && e.boundingClientRect.top < 0);
      }).observe(buyRow);
      var sBtn = sticky.querySelector('[data-gsp-add]');
      if (sBtn && mainAdd) {
        sBtn.addEventListener('click', function () {
          if (!mainAdd.disabled) mainAdd.click();
          else buyRow.scrollIntoView({ behavior: 'smooth', block: 'center' });
        });
      }
    }
  }

  function boot() { document.querySelectorAll('[data-gsp]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', boot);
})();
